import React from 'react';
import { useQueryParams } from '@/hooks/useQueryParams';
import { getUrls } from '@cliengo/mfe-utils/utils';

export const Header: React.FC = () => {
  const { returnUrl } = useQueryParams();

  const handleGoBack = () => {
    if (returnUrl) {
      window.location.href = returnUrl;
    } else {
      window.location.href = getUrls().DASH_URL;
    }
  };
  return (
    <div className="text-center mb-8">
      
      <div className="flex items-center justify-center gap-3 mb-4">
        <div className="p-3 bg-green-100 rounded-full">
          <svg width="28" height="28" viewBox="0 0 28 28" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path fillRule="evenodd" clipRule="evenodd" d="M5.17004 24.7844L7.15194 24.4302L8.35617 24.2175C10.0559 25.1385 11.9678 25.6339 13.9497 25.6339C20.3949 25.6339 25.6349 20.3936 25.6349 13.95C25.6349 7.50593 20.3949 2.26606 13.9497 2.26606C7.50606 2.26606 2.2661 7.50593 2.2661 13.95C2.2661 16.287 2.97436 18.4112 4.10766 20.2522L3.96631 21.3146L3.68261 23.679L3.47033 25.0675L5.17004 24.7844ZM14.8708 14.8705H12.0388V18.0571H14.4457C15.5081 18.0571 16.9246 17.703 16.9246 16.3574C16.9246 16.3574 16.8537 14.8705 14.8708 14.8705ZM15.2249 9.63065H12.0388V12.8172H14.5167C14.9412 12.8172 16.7828 12.6754 16.9246 11.1175C16.9246 11.1175 16.8537 9.84292 15.2249 9.63065ZM10.1268 7.7187H15.2249C15.2249 7.7187 18.9075 7.57685 18.9784 11.0466C18.9784 11.0466 19.1203 12.6044 17.4201 13.5959C17.4201 13.5959 19.2616 14.375 19.2616 16.5702C19.2616 16.5702 19.2616 20.3936 14.7289 19.969H10.0559C9.84309 19.969 9.70174 19.8272 9.70174 19.6149V8.0019C9.70174 7.86005 9.84309 7.7187 10.0559 7.7187H10.1268ZM13.9497 0C21.6686 0 27.9 6.2318 27.9 13.95C27.9 21.6682 21.6686 27.9 13.9497 27.9C11.8265 27.9 9.84309 27.404 8.07246 26.6254L0.637326 27.9L1.62878 20.5354L1.55785 20.3936C0.5664 18.4821 0 16.287 0 13.95C0 6.2318 6.23242 0 13.9497 0Z" fill="#2AD168"/>
          </svg>
        </div>
        <h1 className="text-2xl font-normal text-gray-800">
          Integración Whatsapp Business
        </h1>
      </div>
      <p className="text-gray-600 max-w-2xl mx-auto">
        Conecta tu línea de WhatsApp a <strong>Cliengo</strong> para gestionar las conversaciones sin perder acceso desde tu celular.
      </p>
    </div>
  );
};